export const engagementAppGroupIdGenerateVideoPresignedUrl =
  "/engagement/:app_group_id/generate_video_presigned_url/:asset_id";
